import { render, staticRenderFns } from "./Boundless.vue?vue&type=template&id=0dd81be2&"
import script from "./Boundless.vue?vue&type=script&lang=js&"
export * from "./Boundless.vue?vue&type=script&lang=js&"
import style0 from "./Boundless.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports